/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-23.
 */
import React, { Component } from 'react';
import { TextField } from 'material-ui';
import { v1 } from 'node-uuid';
import { buildErrorsState, validateField, errorsEmpty } from '../../validations';

const errorsProps = {
    porcentajeError: [],
    cajaError: [],
    contenedorError: [],
};

const rules = {
    porcentajeError: [
      { key: 'required', errorText: 'Campo requerido' },
      { key: 'moreThanZero', errorText: 'Por favor, indicar un valor mayor a 0' }
    ],
    cajaError: [
      { key: 'required', errorText: 'Campo requerido' },
      { key: 'moreThanZero', errorText: 'Por favor, indicar un valor mayor a 0' }

    ],
    contenedorError: [
      { key: 'required', errorText: 'Campo requerido' },
      { key: 'moreThanZero', errorText: 'Por favor, indicar un valor mayor a 0' }
    ]
};

class Honorarios extends Component {

    constructor() {
        super();
        this.id = v1();
        this.state = {
            porcentaje: '',
            caja: '',
            contenedor: '',
            errors: {...errorsProps}
        };
    }

    updateHonorarios( value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        this.setState({ errors });
    }

    render() {
        const { porcentaje, caja, contenedor, errors} = this.state;
        const { notify, searchText= {porcentaje:'', contenedor:'', caja: ''}} = this.props;

        return (
            <div id={this.id}>
                <div className="col-xs-12">
                    <div className="col-md-12 margin-bottom-1 no-paddings">
                        <p className="text-bold">Honorarios</p>
                    </div>
                    <div className="col-md-12 webkit-box no-paddings">
                        <div className="col-md-3 pl0">
                            <TextField
                                id={`${this.id}_porcentaje`}
                                fullWidth
                                type="number"
                                value={searchText.porcentaje}
                                errorText={errors.porcentajeError.join(' | ')}
                                onChange={(event, value) => {
                                    this.setState({ porcentaje: value });
                                    this.updateHonorarios( value, 'porcentajeError')
                                    notify({ porcentaje: value, caja: searchText.caja, contenedor: searchText.contenedor});
                                }}
                            />
                        </div>
                        <p style={{marginTop:'8%'}}>%</p>
                    </div>
                    <div className="col-md-12 no-paddings">
                        <div className="col-md-5 pl0">
                            <TextField
                                id={`${this.id}_caja`}
                                fullWidth
                                type="number"
                                value={searchText.caja}
                                errorText={errors.cajaError.join(' | ')}
                                onChange={(event, value) => {
                                    this.setState({ caja: value });
                                    this.updateHonorarios( value, 'cajaError')
                                    notify({ porcentaje: searchText.porcentaje, caja: value, contenedor: searchText.contenedor });
                                }}
                            />
                        </div>
                        <p style={{marginTop:'8%'}}>minimo por Caja / Plataforma / LCL</p>
                    </div>
                </div>

                <div className="col-xs-12 margin-top-2">
                    <div className="col-md-12 margin-bottom-1 no-paddings">
                        <p className="text-bold">Complementarios</p>
                    </div>
                    <div className="col-md-12 no-paddings">
                        <div className="col-md-5 pl0">
                            <TextField
                                id={`${this.id}_contenedor`}
                                fullWidth
                                type="number"
                                value={searchText.contenedor}
                                errorText={errors.contenedorError.join(' | ')}
                                onChange={(event, value) => {
                                    this.setState({ contenedor: value });
                                    this.updateHonorarios( value, 'contenedorError')
                                    notify({ porcentaje: searchText.porcentaje, caja: searchText.caja, contenedor: value });
                                }}
                            />
                        </div>
                        <p style={{marginTop:'8%'}}>por Contenedor</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Honorarios;



// WEBPACK FOOTER //
// ./forms/customTabulador/honorarios.js